import React from 'react'
import { StyleSheet, TouchableOpacity, View } from 'react-native'

import { colors } from '../styles/global'
import Icon from '../Icon'
import useEscapeKey from '../../hooks/useEscapeKey'

export default function CloseButton({ close, style, disabledEscape }) {
    const onPress = event => {
        setTimeout(() => {
            close(event)
        })
    }

    // On the LIFO escape stack (AT-2257) rather than a document listener: a
    // picker opened over the modal now takes Escape first and the modal
    // survives, and Escape works while a react-native-web input has focus.
    // This upgrades every modal that renders this button at once.
    useEscapeKey(close, { enabled: !disabledEscape })

    return (
        <View style={[localStyles.closeContainer, style]}>
            <TouchableOpacity style={localStyles.closeButton} onPress={onPress}>
                <Icon name="x" size={24} color={colors.Text03} />
            </TouchableOpacity>
        </View>
    )
}

const localStyles = StyleSheet.create({
    closeContainer: {
        position: 'absolute',
        top: 13,
        right: 13,
        // react-native-web gives every View `z-index: 0` and every Text
        // `position: relative`, so the close button and the sibling title /
        // description Texts are all *positioned* boxes in the same stacking
        // context and paint in tree order. Headers that render this button
        // before their title (ModalHeader, and most modals that use
        // CloseButton directly) therefore had the full-width title box painted
        // on top of the button, swallowing the click over most of the X --
        // including its centre. Lift it above its siblings; the parent View's
        // own `z-index: 0` keeps this contained to the header.
        zIndex: 1,
    },
    closeButton: {
        alignItems: 'center',
        justifyContent: 'center',
        // Grow the 24px icon to a 44px touch target without moving it or
        // affecting any caller's absolute positioning of closeContainer.
        padding: 10,
        margin: -10,
    },
})
